export class NameTooLongError extends Error {}
export class NameNotValidError extends Error {}
